import { useParams } from 'react-router-dom'
import { NewLodgingLocationPage } from '../new-company-pages/NewLodgingLocationPage'

export default function LodgingDoorPage() {
  const urlParams = useParams()
  const lodgingID = urlParams.lodging_id!

  return <NewLodgingLocationPage lodgingID={parseInt(lodgingID)} />
}
